<template>
  <div class="qa">
    <template v-for="(item, index) in qa">
      <div>
        <Item
          :key="item.title"
          :title="item.title"
          :content="item.content"
          :index="index"
          :isLast="index === qa.length - 1"
          :open="index === activeId"
          @updateActiveId="updateActiveId"
        >
        </Item>
      </div>
    </template>
  </div>
</template>

<script>
import Item from "./Item.vue";

import qaData from "../../models/Qa.js";

export default {
  name: "Question",
  components: {
    Item,
  },
  data: function () {
    return {
      qa: qaData,
      activeId: null,
    };
  },
  methods: {
    updateActiveId: function (index) {
      if (index === this.activeId) {
        this.activeId = null;
      } else {
        this.activeId = index;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../static/styles/palette.scss";

.qa {
  background-color: $darkGray;
}
</style>



// WEBPACK FOOTER //
// Question.vue?4d180e28